import { Controller } from "@hotwired/stimulus"

// When this controller is inside a Turbo Frame response (e.g. after a form submit),
// it moves the toast element into the layout's #toasts container and removes it after a delay.
export default class extends Controller {
  static values = {
    removeAfter: { type: Number, default: 5000 }
  }

  connect() {
    const container = document.getElementById("toasts")
    if (!container) return

    const toast = this.element.querySelector("[data-toast]") || this.element.firstElementChild
    if (!toast) return

    container.appendChild(toast)
    this.element.remove()

    setTimeout(() => {
      toast.remove()
    }, this.removeAfterValue)
  }
}
